import React from "react";
import { ArrowLeft } from "lucide-react";

/**
 * QuestionStep — single full-screen question. Tapping any option calls
 * onSelect immediately (auto-advance, no Next button).
 *
 * Accepts either:
 *   options: [{ value, label }, ...]   -> renders option cards
 *   custom:  React node                -> caller renders its own input
 *                                         and calls onSelect when ready.
 */
export default function QuestionStep({
  index,
  total,
  question,
  hint,
  options,
  custom,
  onSelect,
  onBack,
  testid,
  showPrivacy = false,
}) {
  return (
    <div className="fade-in" data-testid={testid}>
      <div className="flex items-center justify-between mb-6">
        {onBack ? (
          <button onClick={onBack}
            className="inline-flex items-center gap-1.5 text-sm transition-colors hover:text-gray-900"
            style={{ color: "#6b7280" }}
            data-testid="netprice-step-back">
            <ArrowLeft className="w-3.5 h-3.5" /> Back
          </button>
        ) : <span />}
        <span className="text-xs uppercase tracking-[0.18em]" style={{ color: "#9ca3af" }}>
          Step {index} of {total}
        </span>
      </div>

      {showPrivacy && (
        <div className="mb-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-md text-[11px] uppercase tracking-[0.14em]"
          style={{ background: "#ecfdf5", color: "#15803d", border: "1px solid #a7f3d0" }}
          data-testid="netprice-privacy">
          Nothing is saved or sent anywhere
        </div>
      )}

      <h2 className="font-heading leading-[1.1]"
        style={{ color: "#111928", fontSize: "clamp(1.85rem, 3vw, 2.4rem)" }}>
        {question}
      </h2>
      {hint && (
        <p className="mt-3 text-sm sm:text-base" style={{ color: "#6b7280" }}>
          {hint}
        </p>
      )}

      <div className="mt-8">
        {options ? (
          <div className="grid gap-2.5 max-w-xl">
            {options.map(opt => (
              <button
                key={opt.value}
                onClick={() => onSelect(opt)}
                className="text-left px-5 py-4 rounded-lg transition-colors hover:bg-blue-50"
                style={{ background: "#ffffff", border: "1px solid #e5e7eb", color: "#111928" }}
                data-testid={`netprice-option-${opt.value}`}>
                <span className="text-[15px]">{opt.label}</span>
              </button>
            ))}
          </div>
        ) : custom}
      </div>
    </div>
  );
}
